export default __webpack_public_path__ + "static/media/ic-all-tech.76ba10c9.svg";